import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=183cb0f2&scoped=true"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"
import style0 from "./Mail.vue?vue&type=style&index=0&id=183cb0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183cb0f2",
  null
  
)

export default component.exports